
import MonksHeaderWrapper from './MonksHeaderWrapper.vue'

export default {
  name: 'MonksHeader',

  components: {
    MonksHeaderWrapper,
  },

  props: {
    locale: {
      type: String,
      default: 'pt-br',
    },
    navigation: {
      type: Object,
      required: true,
    },
    topbarVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOverlayOpen: false,
      isMenuOpen: false,
      headerTop: null,
    }
  },

  computed: {
    isPT() {
      return this.locale === 'pt-br'
    },

    headerStyle() {
      if (this.headerTop !== null && this.topbarVisible && this.isPT) {
        return { top: `${this.headerTop}px` }
      }

      return {}
    },
  },

  mounted() {
    if (this.topbarVisible && this.isPT) {
      this.handleScroll()
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleScroll)
    }

    window.addEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
    window.removeEventListener('dropdown:toggle', this.handleDropdownToggle)
  },

  methods: {
    handleScroll() {
      const topStripe = document.getElementById('top-stripe')
      if (topStripe) {
        const rect = topStripe.getBoundingClientRect()
        this.headerTop = Math.max(rect.bottom, 0) + 15
      }
    },

    handleDropdownToggle(event) {
      this.isOverlayOpen = event.detail.isActive
    },

    handleMenuToggle(isOpen) {
      this.isMenuOpen = isOpen
    },

    closeOverlay() {
      this.isOverlayOpen = false
    },
  },
}
